import {Component, Renderer2} from '@angular/core';
import {NavigationService} from '../base/navigation/navigation.service';
import {BaseComponent} from '../base/base.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
})
export class DocumentsComponent extends BaseComponent {
  constructor(
    public navigationService: NavigationService,
    public renderer: Renderer2,
    protected router: Router) {
    super(navigationService, router, renderer);
  }
}
